/* projects/fitnessforservice/src/app/import-export/import-export.component.css */
.grayed-out {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.65;
  filter: alpha(opacity=65);
  -webkit-box-shadow: none;
  box-shadow: none;
}
button:first-child {
  margin-right: 10px;
}
/*# sourceMappingURL=import-export.component-NBJDHLGE.css.map */
